import srvAdministracion from './Administracion/Administracion';
import srvApi from './servicioAPI';
import srvPermisos from './servicioPermisos';
import srvValidacion from './servicioValidacion';
import srcChargebee from './servicioChargebee';

export default angular.module("contartemx.servicios", [])
  .factory("apiCall", srvApi)
  .service("ServicioChargebee", srcChargebee)
  .service("SrvAdministracion", srvAdministracion)
  .service("ServicioPermisos", srvPermisos)
  .service("ServicioValidacion", srvValidacion);
